import React from "react";
import CircleGraph from "../../../graphics/svg/circle-graph";
import withLocalization from "../../../hoc/with-localization";
class CircleGraphComponent extends React.Component {
    updateSVG() {
        const circle = new CircleGraph();
        const { angles, loc, needIntervals } = this.props;
        const zoneNames = [
            loc("report.heartAxisAnglePos.extremeLeft"),
            loc("report.heartAxisAnglePos.left"),
            loc("report.heartAxisAnglePos.norm"),
            loc("report.heartAxisAnglePos.right"),
            loc("report.heartAxisAnglePos.extremeRight"),
            loc("report.heartAxisAnglePos.extremeDeviation")
        ];
        let angles_degr = angles ? [angles.QRS.val, angles.P.val, angles.T.val] : null;

        // Скрыть углы P и T, если режим верификации интервалов и репрезентативный комплекс не верифицирован
        if (!needIntervals) {
            angles_degr = angles_degr.map(() => undefined);
        }

        const svg = circle.draw({ angles_degr, radParams: { zoneNames } });

        this.graphContainer.innerHTML = "";
        this.graphContainer.appendChild(svg);
    }
    componentDidUpdate() {
        this.updateSVG();
    }
    componentDidMount() {
        this.updateSVG();
    }
    render() {
        return (
            <div className="medical-report__section report-graph report-graph-radial" ref={_self => (this.graphContainer = _self)}></div>
        );
    }
}

export default withLocalization(CircleGraphComponent);
